import React from "react";
import { TextField } from "@material-ui/core";
import { TextFieldProps } from "@material-ui/core/TextField";

export const TextFieldMemo = React.memo((props: TextFieldProps) => {
    const { children, ...rest } = props;
    return <TextField {...rest}>{children}</TextField>;
});
